import { getTour } from "../tours/registry";
import type { TourId } from "../tours/types";
import { runTour, type TourHandle } from "./run-tour";

export type TourTranslator = (key: string) => string;

export type StartTourCallbacks = {
  onComplete?: () => void;
  onSkip?: () => void;
};

/**
 * Resolve a registered tour's i18n keys with the provided translator (a `useTranslations("onboarding")`
 * instance) and start it. Returns the handle, or null if no target was usable.
 */
export function startTour(tourId: TourId, t: TourTranslator, callbacks: StartTourCallbacks = {}): TourHandle | null {
  const definition = getTour(tourId);
  const steps = definition.steps.map((step) => ({
    target: step.target,
    title: t(step.titleKey),
    description: t(step.descriptionKey),
    side: step.side,
    align: step.align
  }));

  return runTour({
    steps,
    labels: {
      next: t("buttons.next"),
      prev: t("buttons.prev"),
      done: t("buttons.done"),
      skip: t("buttons.skip"),
      progress: t("buttons.progress")
    },
    onComplete: callbacks.onComplete,
    onSkip: callbacks.onSkip
  });
}
